<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ytU3OZ/tc-custom/9780253021526.jpg?1737757760422" alt="This image is the cover for the book Politics of Suffering, Public Cultures of the Middle East and North Africa"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Politics of Suffering, Public Cultures of the Middle East and North Africa
      </h1>
      <p class="bookDescription body article font2">
        <b>With a focus on the residents of three refugee camps, “Gabiam’s nuanced study of Syria’s Palestinian community is an engaging and informative read” (<i>Journal of Palestine Studies</i>).</b><br/><br/><i>The Politics of Suffering</i> examines the confluence of international aid, humanitarian relief, and economic development within the space of the Palestinian refugee camp. Nell Gabiam describes the interactions between UNRWA, the United Nations agency charged with providing assistance to Palestinians since the 1948 Arab-Israeli war, and residents of three camps in Syria. Over time, UNRWA’s management of the camps reveals a shift from an emphasis on humanitarian aid to promotion of self-sufficiency and integration of refugees within their host society.<br/><br/>Gabiam’s analysis captures two forces in tension within the camps: politics of suffering that serves to keep alive the discourse around the Palestinian right of return; and politics of citizenship expressed through development projects that seek to close the divide between the camp and the city. Gabiam also offers compelling insights into the plight of Palestinians before and during the Syrian war, which has led to devastation in the camps and massive displacement of their populations.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nell Gabiam
      </h2>
      
      <p class="authorDescription body article"><P>Nell Gabiam is Assistant Professor of Anthropology and Political Science at Iowa State University.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?583e8379